import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import useApiMethods from '../../lib/useApiMethods';

const PartnerPortalContext = createContext(null);

export function PartnerPortalProvider({ children }) {
  const { fetch: apiFetch } = useApiMethods();
  // Hold apiFetch in a ref so `load` never sees a stale reference and
  // useEffect below can safely depend on nothing (avoids the re-render loop
  // that useApiMethods triggers by returning fresh function references).
  const apiFetchRef = useRef(apiFetch);
  useEffect(() => { apiFetchRef.current = apiFetch; }, [apiFetch]);

  const [who, setWho] = useState(null);        // { kind, id, name }
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = async () => {
    setLoading(true);
    try {
      const resp = await apiFetchRef.current('engage/portal/whoami/');
      if (resp?.status === 'fail') {
        setError(resp.message || 'Not authorised as a partner');
        setWho(null);
      } else {
        setWho(resp?.data || null);
        setError(null);
      }
    } catch (e) {
      setError(e?.response?.data?.message || 'Not authorised as a partner');
      setWho(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, []);

  return (
    <PartnerPortalContext.Provider value={{ who, loading, error, reload: load }}>
      {children}
    </PartnerPortalContext.Provider>
  );
}

export function usePartnerPortal() {
  const ctx = useContext(PartnerPortalContext);
  if (!ctx) throw new Error('usePartnerPortal must be used inside PartnerPortalProvider');
  return ctx;
}
